import SectionTitle from 'components/SectionTitle';
import React from 'react';
import ServiceCard from './ServiceCard';
import withAnimation from 'HOCs/withAnimation';
import f1 from 'assets/images/bafancy-feature-1.png';
import f2 from 'assets/images/bafancy-feature-2.png';

const WorkProcess = () => {
  const services = [
    {
      label: 'Profile preview',
      title: 'Noticeable',
      img: f1,
      caption: 'visually appealing can help engage and retain your followers',
      btnText: 'Make your banner'
    },
    {
      label: 'Guide steps',
      title: 'Simple & Helpful',
      img: f2,
      caption: 'Ready to use templates, just pick one and start customization.',
      btnText: 'Start editing'
    }
  ];
  const renderServices = services.map(({ btnText, img, label, title, caption }, index) => (
    <ServiceCard
      btnText={btnText}
      img={img}
      label={label}
      title={title}
      caption={caption}
      key={index}
    />
  ));

  return (
    <section className="my-10 md:my-32" id="features">
      <SectionTitle title="Features" />
      <div className="mt-16 px-6">
        <div className="flex justify-center gap-[100px] flex-col">{renderServices}</div>
      </div>
    </section>
  );
};

export default withAnimation(WorkProcess);
